/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MailOffIcon16Solid = forwardRef('MailOffIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.386.284A1 1 0 0 0 .989 1.716l.897.875A2.495 2.495 0 0 0 1 4.5v6A2.5 2.5 0 0 0 3.5 13h9.05l1.502 1.466a1 1 0 1 0 1.396-1.432L2.386.284Zm6.426 9.067L4.079 4.732a.75.75 0 0 0-.849 1.215l2.862 2.756a2.75 2.75 0 0 0 2.72.648Z" }),
        React.createElement("path", { d: "m12.77 5.947-1.227 1.181 3.456 3.456L15 10.5v-6A2.5 2.5 0 0 0 12.5 2H6.414l4.068 4.068 1.247-1.202a.75.75 0 0 1 1.04 1.08Z" })));
});
